import { gql } from "lib/apolloClient";
import { subjectFragment } from "modules/CommonFragments";

export const createSubjectMutation = gql`
  mutation createSubject(
    $name: String!
    $grades: [ID!]
    $icon: String
    $subjectGroupId: ID
    $curriculumProgramId: ID
    $presetSubjectId: ID
    $tags: [ID!]
  ) {
    platform {
      createSubject(
        input: {
          name: $name
          icon: $icon
          grades: $grades
          subjectGroupId: $subjectGroupId
          curriculumProgramId: $curriculumProgramId
          presetSubjectId: $presetSubjectId
          tags: $tags
        }
      ) {
        ...subjectItem
      }
    }
  }
  ${subjectFragment.subjectBenchmarkDetails}
`;

export const createSubjectMutationV2 = gql`
  mutation createSubject(
    $name: String!
    $grades: [ID!]
    $icon: String
    $iconType: SUBJECT_ICON_TYPE_ENUM = ICON
    $subjectGroupId: ID
    $curriculumProgramId: ID
    $presetSubjectId: ID
    $tags: [ID!]
  ) {
    platform {
      createSubjectV2(
        input: {
          name: $name
          icon: $icon
          iconType: $iconType
          grades: $grades
          subjectGroupId: $subjectGroupId
          curriculumProgramId: $curriculumProgramId
          presetSubjectId: $presetSubjectId
          tags: $tags
        }
      ) {
        isSuccess
        warning
        subject {
          ...subjectItem
        }
      }
    }
  }
  ${subjectFragment.subjectBenchmarkDetails}
`;

export const updateSubjectMutation = gql`
  mutation updateSubject(
    $id: ID!
    $name: String
    $grades: [ID!]
    $icon: String
    $addedTags: [ID!]
    $removedTags: [ID!]
    $isArchived: Boolean
  ) {
    platform {
      updateSubject(
        input: {
          id: $id
          name: $name
          grades: $grades
          icon: $icon
          addedTags: $addedTags
          removedTags: $removedTags
          isArchived: $isArchived
        }
      ) {
        id
        name
        grades {
          id
        }
        tags {
          id
        }
        isArchived
      }
    }
  }
`;

export const updateSubjectMutationV2 = gql`
  mutation updateSubject(
    $id: ID!
    $name: String
    $grades: [ID!]
    $icon: String
    $iconType: SUBJECT_ICON_TYPE_ENUM = ICON
    $addedTags: [ID!]
    $removedTags: [ID!]
    $isArchived: Boolean
    $subjectGroup: ID
  ) {
    platform {
      updateSubjectV2(
        input: {
          id: $id
          name: $name
          grades: $grades
          icon: $icon
          iconType: $iconType
          addedTags: $addedTags
          removedTags: $removedTags
          isArchived: $isArchived
          subjectGroup: $subjectGroup
        }
      ) {
        isSuccess
        warning
        subject {
          id
          name
          icon
          iconType
          grades {
            id
          }
          tags {
            id
          }
          isArchived
        }
      }
    }
  }
`;

export const deleteSubjectMutation = gql`
  mutation deleteSubject($id: ID!) {
    platform {
      deleteSubject(input: { id: $id })
    }
  }
`;
